import React, { useState } from 'react'
import Section from '../../../../../../components/Section'
import MoneyInput from '../../../../../../components/form/MoneyInput'
import CurrencySelector from '../../../../../../components/currency/CurrencySelector'
import CurrencyExchangeRateInput from '../../../../../../components/currency/CurrencyExchangeRateInput'
import CurrencyDateSelector from '../../../../../../components/currency/CurrencyDateSelector'
import { PurchaseContractErrors, CurrencyList } from '../types'

import HoverTooltip from '../../../../../../components/HoverTooltip'

type Props = {
    name: string
    theme: string
    onNameChange: (value: string) => void
    minRequirements: string
    onMinRequirementsChange: (value: string) => void
    contractPriceReason: string
    onContractPriceReasonChange: (value: string) => void
    nmcd: number
    onNmcdChange: (value: number) => void
    isNmcdWithTax: boolean
    onNmcdWithTaxChange: (value: boolean) => void
    currency: number | null
    onCurrencyChange: (value: number) => void
    currencyExchangeDate?: Date
    onCurrencyExchangeDateChange?: (value: Date, isRetry: boolean) => void
    currencyExchangeRate?: number
    onCurrencyExchangeRateChange?: (value: number) => void
    currencyData: CurrencyList[]
    posAfterSecondYear: boolean
    isMspSecondYear: boolean
    errors?: PurchaseContractErrors
}

const _maybeGetCurrencyConversionInfo = (props: Props) => {
    if (
        props.currency !== 643 &&
        props.currencyExchangeDate &&
        props.onCurrencyExchangeDateChange &&
        props.currencyExchangeRate &&
        props.onCurrencyExchangeRateChange
    ) {
        return (
            <>
                <div className="mt-2 flex flex-col min-w-[200px]">
                    <CurrencyDateSelector
                        value={props.currencyExchangeDate}
                        onChange={props.onCurrencyExchangeDateChange}
                        theme={props.theme}
                        error={props.errors}
                    />
                </div>
                <div className="mt-2 flex flex-col min-w-[200px]">
                    <CurrencyExchangeRateInput
                        value={props.currencyExchangeRate ?? 0}
                        onChange={props.onCurrencyExchangeRateChange}
                    />
                </div>
                <div className="mt-2 flex flex-col min-w-[200px]">
                    <span className="text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                        Сведения о НМЦД (в руб.)
                    </span>
                    <MoneyInput
                        value={props.nmcd * props.currencyExchangeRate}
                        disabled={true}
                        className={`form-input px-2 py-1 h-[28px] rounded-md text-sm ${
                            props.errors?.maximum_contarct_price_rub
                                ? 'border border-[#C15C5C]'
                                : 'border border-[#2A282B]'
                        }`}
                    />
                </div>
            </>
        )
    }
}

const PurchaseContractInfo: React.FC<Props> = (props) => {
    return (
        <Section title="Информация о предмете договора">
            <div className="flex flex-col w-full">
                <label className="mb-1 text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                    Наименование предмета договора
                </label>
                <HoverTooltip
                    tooltipText={props.errors?.contract_subject || ''}
                >
                    <textarea
                        className={`form-textarea ${
                            props.errors?.contract_subject
                                ? 'border border-[#ff5353] dark:border-[#C15C5C]'
                                : ''
                        }`}
                        maxLength={2000}
                        rows={3}
                        value={props.name || ''}
                        onChange={(e) => props.onNameChange(e.target.value)}
                    />
                </HoverTooltip>

                <label className="mt-2 mb-1 text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                    Минимально необходимые требования, предъявляемые к
                    закупаемым товарам, работам, услугам
                </label>
                <HoverTooltip
                    tooltipText={props.errors?.minimum_requirements || ''}
                >
                    <textarea
                        className={`form-textarea ${
                            props.errors?.minimum_requirements
                                ? 'border border-[#C15C5C]'
                                : ''
                        }`}
                        maxLength={2000}
                        rows={3}
                        value={props.minRequirements || ''}
                        onChange={(e) =>
                            props.onMinRequirementsChange(e.target.value)
                        }
                    />
                </HoverTooltip>

                {!props.posAfterSecondYear &&
                    !props.isMspSecondYear == true && (
                        <>
                            <label className="mt-2 mb-1 text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                Обоснование начальной (максимальной) цены
                                договора
                            </label>
                            <HoverTooltip
                                tooltipText={props.errors?.order_pricing || ''}
                            >
                                <textarea
                                    className={`form-textarea ${
                                        props.errors?.order_pricing
                                            ? 'border border-[#C15C5C]'
                                            : ''
                                    }`}
                                    maxLength={2000}
                                    rows={3}
                                    value={props.contractPriceReason || ''}
                                    onChange={(e) =>
                                        props.onContractPriceReasonChange(
                                            e.target.value
                                        )
                                    }
                                />
                            </HoverTooltip>

                            <div className="flex flex-row flex-wrap gap-x-5 ">
                                <HoverTooltip
                                    tooltipText={
                                        props.errors?.maximum_contarct_price ||
                                        ''
                                    }
                                >
                                    <div className="mt-2 flex flex-col min-w-[200px] ">
                                        <span className="form-label">
                                            Сведения о НМЦД
                                        </span>
                                        <MoneyInput
                                            value={props.nmcd}
                                            onChange={props.onNmcdChange}
                                            className={`form-input ${
                                                props.errors
                                                    ?.maximum_contarct_price
                                                    ? 'border border-[#C15C5C]'
                                                    : ''
                                            }`}
                                        />
                                    </div>
                                </HoverTooltip>

                                <div className="mt-2 flex flex-col min-w-[200px]">
                                    <CurrencySelector
                                        value={
                                            props.currency !== null
                                                ? String(props.currency)
                                                : ''
                                        }
                                        currencyData={props.currencyData}
                                        onChange={props.onCurrencyChange}
                                    />
                                </div>

                                {_maybeGetCurrencyConversionInfo(props)}

                                <div className="mt-2 flex flex-col min-w-[200px] ">
                                    <span className="form-label">
                                        НМЦД включает НДС
                                    </span>
                                    <select
                                        className="form-select"
                                        value={
                                            props.isNmcdWithTax ? 'yes' : 'no'
                                        }
                                        onChange={(e) =>
                                            props.onNmcdWithTaxChange(
                                                e.target.value === 'yes'
                                            )
                                        }
                                    >
                                        <option value="yes">Да</option>
                                        <option value="no">Нет</option>
                                    </select>
                                </div>
                            </div>
                        </>
                    )}
            </div>
        </Section>
    )
}

export default PurchaseContractInfo
